import CustomWindow from 'interfaces/Utils';

declare let window: CustomWindow;

const showRegister = (): void => {
  window.tp.pianoId.show({ screen: 'register' });
};

export default showRegister;
